<template>
  <div class="l-app-wrap" :class="[versionCssClass, pageCssClass]">
    <ScreenTooSmall />
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import ScreenTooSmall from './components/ScreenTooSmall'

function makeSafeForCss(name) {
    return name.replace(/[^a-z0-9]/g, function(s) {
        var c = s.charCodeAt(0);
        if (c == 32) return '-';
        if (65 <= c && c <= 90) return '_' + s.toLowerCase();
        return '__' + ('000' + c.toString(16)).slice(-4);
    });
}

export default {
  name: 'App',
  components: {
    ScreenTooSmall
  },
  computed: {
    versionCssClass(){
      if(this.$isUcas){
        return 'ucas'
      }
      if(this.$isUnite){
        return 'unite'
      }
      return ''
    },
    pageCssClass(){
      return this.$route.meta.pageCssClass || 
              makeSafeForCss('home') || 
              'page'
    }
  }
}
</script>

<style>
body {
  background: #272727;
  background-image:url(./assets/images/logo-background.png);
}

.container {
  padding: 10px;
}
</style>

<style src='./assets/scss/styles.scss' lang='scss' />



// WEBPACK FOOTER //
// src/App.vue